import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { UserContext } from '../../context/user';
import DialogRoutes from './dialog-routes';
import Maintenance from '../../views/error/maintenance';
import Loading from '../../views/loading/loading';
import BrowserRoutes from './browser-routes';
export default function Router() {
    var _a = useContext(UserContext), user = _a.user, systemInfo = _a.systemInfo, ctaServerMaintenance = _a.ctaServerMaintenance;
    if (user === undefined || systemInfo === undefined || ctaServerMaintenance === undefined) {
        return _jsx(Loading, {});
    }
    if (ctaServerMaintenance) {
        return _jsx(Maintenance, {});
    }
    return (_jsx(Suspense, { fallback: Loading(), children: _jsxs(BrowserRouter, { children: [_jsx(BrowserRoutes, {}), _jsx(DialogRoutes, {})] }) }));
}
